// Per-cell writes that keep the running in-range counters honest.

import type { Ctx } from './ctx';

/** Set a cell's length and update mow/trim in-range counts. Does not push dirty. */
export function setLength(ctx: Ctx, i: number, len: number): void {
  const g = ctx.grid;
  g.lengthMm[i] = len;
  const inr = len >= g.lo[i] && len <= g.hi[i] ? 1 : 0;
  if (inr !== ctx.inRange[i]) {
    const d = inr ? 1 : -1;
    if (g.mowable[i]) ctx.inRangeCells += d;
    else if (g.trim[i]) ctx.inRangeTrim += d;
    ctx.inRange[i] = inr;
  }
}

/** Initialise ctx.inRange / counters from current lengths. */
export function initInRange(ctx: Ctx): void {
  const g = ctx.grid;
  ctx.inRangeCells = 0;
  ctx.inRangeTrim = 0;
  for (let i = 0; i < g.type.length; i++) {
    if (!g.mowable[i] && !g.trim[i]) continue;
    const len = g.lengthMm[i];
    const inr = len >= g.lo[i] && len <= g.hi[i] ? 1 : 0;
    ctx.inRange[i] = inr;
    if (inr) {
      if (g.mowable[i]) ctx.inRangeCells++;
      else ctx.inRangeTrim++;
    }
  }
}

export function wrapAngle(a: number): number {
  a = (a + Math.PI) % (2 * Math.PI);
  if (a < 0) a += 2 * Math.PI;
  return a - Math.PI;
}

/** Heading → 0..255 (0..2π). */
/** Crossed stripes: a later pass this far off an earlier one's axis (60°, in 256ths of a turn) crosses it. */
export const CROSS_Q = 43;

/** Angle between two quantised headings' axes (direction ignored), 0..64 in 256ths of a turn. */
export function axisGap(a: number, b: number): number {
  const d = Math.abs(a - b) & 127;
  return d > 64 ? 128 - d : d;
}

export function quantiseHeading(h: number): number {
  let a = h % (2 * Math.PI);
  if (a < 0) a += 2 * Math.PI;
  return Math.round((a / (2 * Math.PI)) * 256) & 255;
}
